import { render, staticRenderFns } from "./ustekveikja.vue?vue&type=template&id=33baa2f0&scoped=true&"
import script from "./ustekveikja.vue?vue&type=script&lang=js&"
export * from "./ustekveikja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33baa2f0",
  null
  
)

export default component.exports